/// <reference types="./getReferenceEntitiesInfo.d.ts" />
import { ok } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryMany } from '../QueryFunctions.js';
import { assertIsDefined } from '../utils/AssertUtils.js';
export async function adminEntityGetReferenceEntitiesInfo(database, context, references) {
    if (references.length === 0)
        return ok([]);
    const { addValueList, query, sql } = createSqliteSqlQuery();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    sql `SELECT id, uuid, type, status FROM entities WHERE uuid IN ${addValueList(references.map(({ id }) => id))}`;
    const result = await queryMany(database, context, query);
    if (result.isError())
        return result;
    return ok(result.value.map((it) => {
        assertIsDefined(it.uuid);
        return {
            entityInternalId: it.id,
            id: it.uuid,
            type: it.type,
            status: it.status,
        };
    }));
}
//# sourceMappingURL=getReferenceEntitiesInfo.js.map